module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/regenerator/index.js
// module id = 246
// module chunks = 1